import '../../styles/app.scss'
import '../../styles/pages/contest.scss';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ReactGA from 'react-ga4';

const RCC = () => {

  useEffect(()=>{
    ReactGA.initialize("UA-132563689-8");
  })
  
  const [invisible, setInvisible] = useState(true)
  const [success, changeSuccess] = useState(false)
  const [error, changeError] =  useState(false)
  const [results, setResults] = useState(false)
  const [psVote, setPSVote] = useState()
  const [nswVote, setNSWVote] = useState()
  const [fullscreen, setFullscreen] = useState("")
  
  const [ps4One, updatePS4One] = useState()
  const [ps4Two, updatePS4Two] = useState()
  const [ps4Three, updatePS4Three] = useState()

  const [nswOne, updateNSWOne] = useState()
  const [nswTwo, updateNSWTwo] = useState()
  const [nswThree, updateNSWThree] = useState() 


  const submitVote = () => {
    setInvisible(false)
    ReactGA.event({
      category: 'Button',
      action: 'Click',
      label: 'Submit Vote'
    })
    axios.post("https://mds.nisamerica.com/contest-api/zero-reverse-cover",{
      dataObj: {
        nsw: `ps4-${psVote}`,
        ps4: `nsw-${nswVote}`
      },
      img: ""
    })
    .then ((response)=>{
      changeSuccess(true)
    }, (error) => {
      changeError(true)
    })
  }

  useEffect(()=>{
    const getResults = async () => {
      const response = await axios.get("https://mds.nisamerica.com/contest-api/safe/zero-reverse-cover")
      updateNSWOne(response.data.ordered.find(e => e.item==="nsw-1").votes)
      updateNSWTwo(response.data.ordered.find(e => e.item==="nsw-2").votes)
      updateNSWThree(response.data.ordered.find(e => e.item==="nsw-3").votes)
      updatePS4One(response.data.ordered.find(e => e.item==="ps4-1").votes)
      updatePS4Two(response.data.ordered.find(e => e.item==="ps4-2").votes)
      updatePS4Three(response.data.ordered.find(e => e.item==="ps4-3").votes)
    }
    getResults()
  }, [results])

  return (
    <div className="reverse">
      <div className={`shadow-box ${invisible ? "invisible" : false}`}>
        {
          fullscreen && <div className={`large-image ${fullscreen ? false : "invisible"}`}>
            <img src={fullscreen} alt="Enlarged Packshot" />
          </div>
        }
        {
          success && <div className={`success ${success ? false : "invisible"}`}>
            <h1 className='captcha'>Your vote has been cast!</h1>
            <button className="submit" onClick={()=>{
              changeSuccess(false)
              setResults(true)
            }}>
              <h1>View Results!</h1>
            </button>
          </div>
        }
        {
          error && <div className={`error ${error ? false : "invisible"}`}>
          <h1>There was an error casting your vote. Please try again!</h1>
        </div>
        }
        { 
          results && <div className={`results ${results ? false : invisible}`}>
            <h1 className="captcha">
              Current Results
            </h1>
            <div className="results-list">
              <h1 className="captcha">PS4™ Results</h1>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_PS4_1.webp" alt="" />
                <div className="bar" style={{width:  `${ps4One / (ps4One+ps4Two+ps4Three) * 100}%`, transition: '1s'}}>
                  <h1>{ps4One}</h1>
                </div>
              </div>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_PS4_2.webp" alt="" />
                <div className="bar" style={{width: `${ps4Two / (ps4One+ps4Two+ps4Three) * 100}%`}}>
                  <h1>{ps4Two}</h1>
                </div>
              </div>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_PS4_3.webp" alt="" />
                <div className="bar" style={{width: `${ps4Three / (ps4One+ps4Two+ps4Three) * 100}%`}}>
                  <h1>{ps4Three}</h1>
                </div>
              </div>
            </div>
            <div className="results-list">
              <h1 className="captcha">Nintendo Switch™ Results</h1>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_NSW_1.webp" alt="" />
                <div className="bar" style={{width:  `${nswOne / (nswOne+nswTwo+nswThree) * 100}%`}}>
                  <h1>{nswOne}</h1>
                </div>
              </div>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_NSW_2.webp" alt="" />
                <div className="bar" style={{width: `${nswTwo / (nswOne+nswTwo+nswThree) * 100}%`}}>
                  <h1>{nswTwo}</h1>
                </div>
              </div>
              <div className="results-pair">
                <img src="./img/cover/Zero_Reverse_NSW_3.webp" alt="" />
                <div className="bar" style={{width: `${nswThree / (nswOne+nswTwo+nswThree) * 100}%`}}>
                  <h1>{nswThree}</h1>
                </div>
              </div>
            </div>

          </div>
        }
        <button className="submit" onClick={()=>{
          setInvisible(true)
          setFullscreen("")
          changeSuccess(false)
          changeError(false)
          setResults(false)
        }}>
          <h1>Close</h1>
        </button>
      </div>
      <div className="hero">
        <div className="logo-wrapper">
          <img src="./img/logo.webp" alt="Trails From Zero Logo" />  
        </div>
        <h1>REVERSE COVER<br/>CONTEST</h1>
      </div>
      <section className="description">
        <p>
          Vote for your favorite alternate cover artwork for a chance to have it included in the physical release of The Legend of Heroes: Trails from Zero for PS4™ and Nintendo Switch™, available 09/27/2022.
        </p>
        <p className="date">
          This contest runs from April 11, 10:00 AM PDT to April 15, 11:59 PM PDT.
        </p>
      </section>
      {
        /*
          
      <div className="voting-section">
        <h1 className="voting-title">
          1. Select a PS4™ Reverse Cover:
        </h1>
        <div className="voting-list">
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_PS4_1.webp)"
              }} htmlFor="PS4 Cover 1">
                <img src="./img/cover/Zero_Reverse_PS4_1.webp" alt="Zero Reverse Cover PS4 #1" />
                <h1>Reverse Cover #1</h1>
                <input type="radio" value="PS4 Cover 1" name="PS4" id="PS4 Cover 1" onChange={()=>{
                  setPSVote(1)
                }}/>
            </label>
            <button className="submit" onClick={()=>{
              setInvisible(false)
              setFullscreen("./img/cover/Zero_Reverse_PS4_1.webp")
            }}>
              <h1>Fullscreen</h1>
            </button>
          </div>
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_PS4_2.webp)"
              }} htmlFor="PS4 Cover 2" onChange={()=>{
                setPSVote(2)
              }}>
                <img src="./img/cover/Zero_Reverse_PS4_2.webp" alt="Zero Reverse Cover PS4 #2" />
                <h1>Reverse Cover #2</h1>
                <input type="radio" value="PS4 Cover 2" name="PS4" id="PS4 Cover 2"/>
            </label>
            <button className="submit" onClick={()=>{
              setInvisible(false)
              setFullscreen("./img/cover/Zero_Reverse_PS4_2.webp")
            }}>
              <h1>Fullscreen</h1>
            </button>
          </div>
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_PS4_3.webp)"
              }} htmlFor="PS4 Cover 3">
                <img src="./img/cover/Zero_Reverse_PS4_3.webp" alt="Zero Reverse Cover PS4 #3" />
                <h1>Reverse Cover #3</h1>
                <input type="radio" value="PS4 Cover 3" name="PS4" id="PS4 Cover 3" onChange={()=>{
                  setPSVote(3)
                }}/>
            </label>
            <button className="submit" onClick={()=>{
              setInvisible(false)
              setFullscreen("./img/cover/Zero_Reverse_PS4_3.webp")
            }}>
              <h1>Fullscreen</h1>
            </button>
          </div>
        </div>
      </div>
      <div className="voting-section">
        <h1 className="voting-title">
          2. Select a Nintendo Switch™ Reverse Cover:
        </h1>
        <div className="voting-list">
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_NSW_1.webp)"
              }} htmlFor="NSW Cover 1">
                <img src="./img/cover/Zero_Reverse_NSW_1.webp" alt="Zero Reverse Cover NSW #1" />
                <h1>Reverse Cover #1</h1>
                <input type="radio" value="NSW Cover 1" name="NSW" id="NSW Cover 1" onChange={()=>{
                  setNSWVote(1)
                }}/>
            </label>
            <button className="submit" onClick={()=>{
                setInvisible(false)
                setFullscreen("./img/cover/Zero_Reverse_NSW_1.webp")
              }}>
                <h1>Fullscreen</h1>
              </button>
          </div>
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_NSW_2.webp)"
              }} htmlFor="NSW Cover 2">
                <img src="./img/cover/Zero_Reverse_NSW_2.webp" alt="Zero Reverse Cover NSW #2" />
                <h1>Reverse Cover #2</h1>
                <input type="radio" value="NSW Cover 2" name="NSW" id="NSW Cover 2" onChange={()=>{
                  setNSWVote(2)
                }}/>
            </label>
            <button className="submit" onClick={()=>{
              setInvisible(false)
              setFullscreen("./img/cover/Zero_Reverse_NSW_2.webp")
            }}>
              <h1>Fullscreen</h1>
            </button>
          </div>
          <div className="voting-area">
            <label className="voting-card" style={{
              backgroundImage: 
                "linear-gradient(rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0.75)), url(./img/cover/Zero_Reverse_NSW_3.webp)"
              }} htmlFor="NSW Cover 3">
                <img src="./img/cover/Zero_Reverse_NSW_3.webp" alt="Zero Reverse Cover NSW #3" />
                <h1>Reverse Cover #3</h1>
                <input type="radio" value="NSW Cover 3" name="NSW" id="NSW Cover 3" onChange={()=>{
                  setNSWVote(3)
                }}/>
            </label>
            <button className="submit" onClick={()=>{
                setInvisible(false)
                setFullscreen("./img/cover/Zero_Reverse_NSW_3.webp")
              }}>
                <h1>Fullscreen</h1>
              </button>
          </div>
        </div>
      </div>
        */
      }
      <div className="button-list">
      {
        /*
                  <button className="submit red" onClick={()=>{submitVote()}}>
                  <h1>
                    Submit Vote!  
                  </h1>
              </button>
        */
      }
        <button className="submit red" onClick={(()=>{
          setInvisible(false)
          setResults(true)
        })}>
            <h1>
              View Final Results
            </h1>
        </button>
      </div>
      <div className="bottom-banner">
        <a href="https://www.thelegendofheroes.com/crossbell/zero/products" target="_blank" rel="noopener noreferrer"
          onClick={()=>{
            ReactGA.event({
              category: "Link",
              action: "Click",
              label: "Preorder Website"
            })
          }}
        >
          Order your copy of The Legend of Heroes: Trails from Zero today!
        </a>
        <a href="https://www.thelegendofheroes.com/crossbell/zero/" target="_blank" rel="noopener noreferrer" 
          onClick={()=>{
            ReactGA.event({
              category: "Link",
              action: "Click",
              label: "Official Website"
            })
          }}
        >
          Visit the official website and learn more about: The Legend of Heroes: Trails from Zero
        </a>
      </div>
    </div>
  );
}

export default RCC;
